import React, { useState, useMemo } from 'react'
import styled from 'styled-components/macro';
import {
  Button, Title, Form, Icon
} from 'components/atoms'
import { Modal, FieldCustom } from 'components/molecules';
import PropTypes from 'prop-types'
import { useToggle } from 'hooks';
import { insertBlock } from 'services/helpers'
import { Formik, Field } from 'formik';
import * as Yup from 'yup';


const VideoSchema = Yup.object().shape({
  url: Yup.string()
    .url('Por favor insira um link válido')
    .required('Campo obrigatório'),
});

export const RichTextEditorOptionVideo = ({
  onChange,
  editorState,
  initialValues,
}) => {
  const [isOpen, toggle] = useToggle();
  const [values, setValues] = useState()

  const handleClick = () => {
    toggle()
  }

  const handleChange = (newProps) => {
    const mergedProps = { ...initialValues, ...newProps }
    setValues(mergedProps)
  }

  const addBlock = () => {
    toggle()
    insertBlock(editorState, onChange, { type: 'VIDEO', data: values })
  }

  const onDiscard = () => {
    toggle()
  }

  const isInitialValid = useMemo(
    () => VideoSchema.isValidSync(initialValues),
    [initialValues]
  );

  return (
    <>
      <Modal isOpen={isOpen} toggle={toggle}>
        <Title>Video</Title>
        <Formik
          initialValues={initialValues}
          isInitialValid={isInitialValid}
          validate={handleChange}
          validationSchema={VideoSchema}
          onSubmit={(values, { setSubmitting }) => {
            addBlock(values)
            setSubmitting(false);
          }}
          enableReinitialize
        >
          {({ isSubmitting }) => (
            <Form>
              <Field
                name="url"
                placeholder="Ex: https://www.youtube.com..."
                info="Insert a video link: youtube, vimeo..."
                component={FieldCustom}
              />
              <Actions>
                <Button
                  type="button"
                  modifiers={['marginRight', 'capitalize']}
                  onClick={onDiscard}
                >
              Cancelar
                </Button>
                <Button
                  type="submit"
                  modifiers={['primary', 'capitalize']}
                  loading={isSubmitting}
                >
              Concluir
                </Button>
              </Actions>
            </Form>
          )}
        </Formik>
      </Modal>
      <Option onClick={handleClick}>
        <Icon icon="fal fa-video" height={16} />
      </Option>
    </>
  )
}

const Option = styled.div`
    padding: ${props => props.theme.spacing.xs2};
    border-radius: 2px;
    margin: 4px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    background: ${props => props.theme.colors.bgLighterS};
    text-transform: capitalize;
    &:hover {
      background-color: #eee;
    }
`

const Actions = styled.div`
  display: flex;
  justify-content: flex-end;
  padding-top: ${props => props.theme.spacing.l};
`;

RichTextEditorOptionVideo.propTypes = {
  onChange: PropTypes.func.isRequired,
  editorState: PropTypes.shape({}).isRequired,
  initialValues: PropTypes.shape({}),
}

RichTextEditorOptionVideo.defaultProps = {
  initialValues: {}
}


export default RichTextEditorOptionVideo
